import { defaultLookup } from 'admin/pages/RiderIndividual/components/RiderCreatePage/staticDatas';
import { ShowRegistration } from 'services/openapi';
export const showDefaultData: ShowRegistration = {
  id: null,
  showName: '',
  season: defaultLookup,
  hostedBy: '',
  showLocation: '',
  isNationalFinal: false,
  natInvite: defaultLookup,
  address: '',
  city: '',
  state: defaultLookup,
  zip: '',
  showStartDate: '',
  showEndDate: '',
  isNatInvite: false,
  numberOfJudges: 1,
};
